import React from 'react';

import { FlatList } from 'react-native';

import { MinimalMenuReorderItemsListItem } from './minimal-menu-reorder-items-list-item';
import { MinimalMappedOrder } from './minimal-menu-reorder-widget-types';

export const MinimalMenuReorderItemsList = ({
  orderEntries,
  ListHeaderComponent,
}: {
  orderEntries: MinimalMappedOrder['orderEntries'];
  ListHeaderComponent: React.ComponentType<any>;
}) => (
  <FlatList
    data={orderEntries}
    renderItem={({ item }) => <MinimalMenuReorderItemsListItem item={item} />}
    keyExtractor={item => item.cartId ?? item.id}
    ListHeaderComponent={ListHeaderComponent}
    stickyHeaderIndices={[0]}
    style={{ width: '100%' }}
  />
);
